<template lang='pug'>
//- VIP訂閱限定
div(:class='$style[`cc-popbox-subscribe-require`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    figure(:class='$style[`cc-content-new-graphic`]')
      img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')
    span.font-medium(:class='$style[`cc-popbox-warning-info`]') 本服務、內容為VIP會員限定，請先訂閱。

    div(:class='$style[`cc-content-controller`]')
      button.btn-extra.font-medium(
        aria-label='知道了'
        tabindex='0'
        :class='$style[`cc-controller-btn`]'
        @click='handleClosePopBox') 知道了

      button.btn-extra.font-medium(
        aria-label='立即訂閱'
        tabindex='0'
        :class='$style[`cc-controller-btn`]'
        @click='handleClickToSubscribe') 立即訂閱

</template>

<script>
import { mapMutations } from 'vuex';

export default {
  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },

    handleClickToSubscribe() {
      this.$router.push({
        path: '/shop/subscribe',
      }).catch(() => true);

      this.handleClosePopBox();
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popSubscribeRequire.scss';
</style>
